import React, { Component, Fragment } from "react";
import Helmet from "react-helmet";

import { title, List } from "utils";

import { Header } from "components";
import { Button } from "antd";

class IncidentListPage extends Component {
  render() {
    const bread = [{ text: "Liste des incidents" }];

    return (
      <Fragment>
        <Helmet>{title("Liste des incidents")}</Helmet>

        <div className="incident-list-page main-content">
          <Header title="Incidents" bread={bread} />
          <List type="incidents" />
        </div>
      </Fragment>
    );
  }
}

export default IncidentListPage;
